import { APIMethod, fetchData } from "@client";

export async function removeTeamMemberQuery(userUuid) {
  try {
    const res = await fetchData("/team", APIMethod.DELETE, {
      data: { userUuid },
    });
    return res.results;
  } catch (e) {
    return [];
  }
}
